export const SET_COMPANIES = "SET_COMPANIES";
export const ADD_NEW_COMPANY = "ADD_NEW_COMPANY";
export const CREATE_COMPANY = "CREATE_COMPANY";
export const REMOVE_COMPANY = "REMOVE_COMPANY";
export const DELETE_COMPANY = "DELETE_COMPANY";
export const SET_SELECTED_COMPANY = "SET_SELECTED_COMPANY";
export const SET_COMPANY = "SET_COMPANY";
export const SET_PAGE = "COMPANY_SET_PAGE";
export const SEARCH_CHANGE = "COMPANY_SEARCH_CHANGE";
